export default __webpack_public_path__ + "static/media/ic_sudan.2733e448.svg";